import styled from 'styled-components';
import { escapeRegexReservedCharacters } from '@algoan/dashboard/utils';
import { lowerCaseAndRemoveAccents } from '@algoan/utils/string';

export const HighlightedSearch: React.FC<{ cellData: string; wordToSearch: string }> = ({ cellData, wordToSearch }) => {
  if (wordToSearch === '') {
    return (
      <div>
        <span>{cellData}</span>
      </div>
    );
  }

  let lengthToSplit = 0;
  const splitCellData: string[] = [];
  const splitSimplifiedCellData = lowerCaseAndRemoveAccents(cellData).split(
    new RegExp(`(${escapeRegexReservedCharacters(lowerCaseAndRemoveAccents(wordToSearch))})`, 'gi'),
  );

  splitSimplifiedCellData.forEach((element) => {
    splitCellData.push(cellData.substring(lengthToSplit, lengthToSplit + element.length));
    lengthToSplit += element.length;
  });

  return (
    <div>
      {splitCellData.map((part: string, index: number) => (
        <S.ConditionalBold
          key={index}
          shouldBeBold={lowerCaseAndRemoveAccents(part) === lowerCaseAndRemoveAccents(wordToSearch)}
        >
          {part}
        </S.ConditionalBold>
      ))}
    </div>
  );
};

const S = {
  ConditionalBold: styled.span<{ shouldBeBold: boolean }>`
    ${({ shouldBeBold }) => (shouldBeBold ? 'font-weight: bold;' : '')}
  `,
};
